import React, { useEffect } from "react";
import { List } from "antd";
import moment from "moment";
import styles from "./BestDayEverPlanningForm.module.css";
import { PlanningTemplatesMiddleware } from "../../../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import { TextComponent } from "../../../../../components";
import fallbackImg from "../../../../../assets/staticImages/fallbackImg.png";

const BestDayEverPlanningForm = () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const WeddingPlannerTemplates = useSelector(
    (state) => state?.PlanningTemplatesReducer?.WeddingPlannerTemplates,
  );

  useEffect(() => {
    dispatch(PlanningTemplatesMiddleware.GetWeddingPlannerTemplates());
  }, [dispatch]);

  return (
    <div>
      {WeddingPlannerTemplates?.length > 0 && (
        <List
          className={styles.list}
          itemLayout={width > 991 ? "horizontal" : "vertical"}
          dataSource={WeddingPlannerTemplates}
          rowKey="id"
          renderItem={(item) => (
            <List.Item className={styles.listItem}>
              <div className={styles.itemContent}>
                <img
                  className={styles.vendorImage}
                  src={item?.vendor_image ? item?.vendor_image : fallbackImg}
                  alt={item?.vendor_name}
                />
                <div className={styles.details}>
                  <text className={styles.title}>
                    <TextComponent text={item?.title} />
                  </text>
                  <div>
                    <text className={styles.vendorName}>
                      <TextComponent>{item?.vendor_name}</TextComponent>
                    </text>
                  </div>
                  <div>
                    <text className={styles.category}>
                      <TextComponent>{item?.vendor_category}</TextComponent>
                    </text>
                  </div>
                </div>

                <TextComponent className={styles.date}>
                  {moment(item?.created_at).format("DD MMM YYYY")}
                </TextComponent>
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default BestDayEverPlanningForm;
